export enum PurposeCode {
  ACCT = 'ACCT',
  ADCS = 'ADCS',
  ADMG = 'ADMG',
  ADVA = 'ADVA',
  AEMP = 'AEMP',
  AGRT = 'AGRT',
  AIRB = 'AIRB',
  ALLW = 'ALLW',
  ALMY = 'ALMY',
  AMEX = 'AMEX',
  ANNI = 'ANNI',
  ANTS = 'ANTS',
  AREN = 'AREN',
  AUCO = 'AUCO',
  B112 = 'B112',
  BBSC = 'BBSC',
  BCDM = 'BCDM',
  BCFG = 'BCFG',
  BECH = 'BECH',
  BENE = 'BENE',
  BEXP = 'BEXP',
  BFWD = 'BFWD',
  BKDF = 'BKDF',
  BKFE = 'BKFE',
  BKFM = 'BKFM',
  BKIP = 'BKIP',
  BKPP = 'BKPP',
  BLDM = 'BLDM',
  BNET = 'BNET',
  BOCE = 'BOCE',
  BOND = 'BOND',
  BONU = 'BONU',
  BR12 = 'BR12',
  BUSB = 'BUSB',
  CABD = 'CABD',
  CAEQ = 'CAEQ',
  CAFI = 'CAFI',
  CASH = 'CASH',
  CBCR = 'CBCR',
  CBFF = 'CBFF',
  CBFR = 'CBFR',
  CBLK = 'CBLK',
  CBTV = 'CBTV',
  CCHD = 'CCHD',
  CCIR = 'CCIR',
  CCPC = 'CCPC',
  CCPM = 'CCPM',
  CCRD = 'CCRD',
  CCSM = 'CCSM',
  CDBL = 'CDBL',
  CDCB = 'CDCB',
  CDCD = 'CDCD',
  CDCS = 'CDCS',
  CDDP = 'CDDP',
  CDEP = 'CDEP',
  CDOC = 'CDOC',
  CDQC = 'CDQC',
  CFDI = 'CFDI',
  CFEE = 'CFEE',
  CGDD = 'CGDD',
  CHAR = 'CHAR',
  CLPR = 'CLPR',
  CMDT = 'CMDT',
  COLL = 'COLL',
  COMC = 'COMC',
  COMM = 'COMM',
  COMP = 'COMP',
  COMT = 'COMT',
  CORT = 'CORT',
  COST = 'COST',
  CPEN = 'CPEN',
  CPKC = 'CPKC',
  CPYR = 'CPYR',
  CRDS = 'CRDS',
  CRPR = 'CRPR',
  CRSP = 'CRSP',
  CRTL = 'CRTL',
  CSDB = 'CSDB',
  CSLP = 'CSLP',
  CVCF = 'CVCF',
  DBCR = 'DBCR',
  DBTC = 'DBTC',
  DCRD = 'DCRD',
  DEBT = 'DEBT',
  DEPD = 'DEPD',
  DEPT = 'DEPT',
  DERI = 'DERI',
  DICL = 'DICL',
  DIVD = 'DIVD',
  DMEQ = 'DMEQ',
  DNTS = 'DNTS',
  DSMT = 'DSMT',
  DVPM = 'DVPM',
  ECPG = 'ECPG',
  ECPR = 'ECPR',
  ECPU = 'ECPU',
  EDUC = 'EDUC',
  EFTC = 'EFTC',
  EFTD = 'EFTD',
  ELEC = 'ELEC',
  ENRG = 'ENRG',
  EPAY = 'EPAY',
  EQPT = 'EQPT',
  EQTS = 'EQTS',
  EQUS = 'EQUS',
  ESTX = 'ESTX',
  ETUP = 'ETUP',
  EXPT = 'EXPT',
  EXTD = 'EXTD',
  FACT = 'FACT',
  FAND = 'FAND',
  FCOL = 'FCOL',
  FCPM = 'FCPM',
  FEES = 'FEES',
  FERB = 'FERB',
  FIXI = 'FIXI',
  FLCR = 'FLCR',
  FNET = 'FNET',
  FORW = 'FORW',
  FREX = 'FREX',
  FUTR = 'FUTR',
  FWBC = 'FWBC',
  FWCC = 'FWCC',
  FWLV = 'FWLV',
  FWSB = 'FWSB',
  FWSC = 'FWSC',
  FXNT = 'FXNT',
  GAFA = 'GAFA',
  GAHO = 'GAHO',
  GAMB = 'GAMB',
  GASB = 'GASB',
  GDDS = 'GDDS',
  GDSV = 'GDSV',
  GFRP = 'GFRP',
  GIFT = 'GIFT',
  GOVI = 'GOVI',
  GOVT = 'GOVT',
  GSCB = 'GSCB',
  GSTX = 'GSTX',
  GVEA = 'GVEA',
  GVEB = 'GVEB',
  GVEC = 'GVEC',
  GVED = 'GVED',
  GWLT = 'GWLT',
  HEDG = 'HEDG',
  HLRP = 'HLRP',
  HLST = 'HLST',
  HLTC = 'HLTC',
  HLTI = 'HLTI',
  HREC = 'HREC',
  HSPC = 'HSPC',
  HSTX = 'HSTX',
  ICCP = 'ICCP',
  ICRF = 'ICRF',
  IDCP = 'IDCP',
  IHRP = 'IHRP',
  INBC = 'INBC',
  INPC = 'INPC',
  INPR = 'INPR',
  INSC = 'INSC',
  INSM = 'INSM',
  INSU = 'INSU',
  INTC = 'INTC',
  INTE = 'INTE',
  INTP = 'INTP',
  INTX = 'INTX',
  INVS = 'INVS',
  IPAY = 'IPAY',
  IPCA = 'IPCA',
  IPDO = 'IPDO',
  IPEA = 'IPEA',
  IPEC = 'IPEC',
  IPEW = 'IPEW',
  IPPS = 'IPPS',
  IPRT = 'IPRT',
  IPU2 = 'IPU2',
  IPUW = 'IPUW',
  IVPT = 'IVPT',
  LBIN = 'LBIN',
  LBRI = 'LBRI',
  LBXX = 'LBXX',
  LCOL = 'LCOL',
  LFEE = 'LFEE',
  LICF = 'LICF',
  LIFI = 'LIFI',
  LIMA = 'LIMA',
  LMEQ = 'LMEQ',
  LMFI = 'LMFI',
  LMRK = 'LMRK',
  LOAN = 'LOAN',
  LOAR = 'LOAR',
  LOTT = 'LOTT',
  LREB = 'LREB',
  LREV = 'LREV',
  LSFL = 'LSFL',
  LTCF = 'LTCF',
  MAFC = 'MAFC',
  MARF = 'MARF',
  MARG = 'MARG',
  MBSB = 'MBSB',
  MBSC = 'MBSC',
  MCDM = 'MCDM',
  MCFG = 'MCFG',
  MDCS = 'MDCS',
  MFSR = 'MFSR',
  MGCC = 'MGCC',
  MGSC = 'MGSC',
  MOMA = 'MOMA',
  MP2B = 'MP2B',
  MP2P = 'MP2P',
  MSVC = 'MSVC',
  MTUP = 'MTUP',
  NETT = 'NETT',
  NITX = 'NITX',
  NOWS = 'NOWS',
  NWCH = 'NWCH',
  NWCM = 'NWCM',
  OCCC = 'OCCC',
  OCDM = 'OCDM',
  OCFG = 'OCFG',
  OFEE = 'OFEE',
  OPBC = 'OPBC',
  OPCC = 'OPCC',
  OPSB = 'OPSB',
  OPSC = 'OPSC',
  OPTN = 'OPTN',
  OTCD = 'OTCD',
  OTHR = 'OTHR',
  OTLC = 'OTLC',
  PADD = 'PADD',
  PAYR = 'PAYR',
  PCOM = 'PCOM',
  PDEP = 'PDEP',
  PEFC = 'PEFC',
  PENO = 'PENO',
  PENS = 'PENS',
  PHON = 'PHON',
  PLDS = 'PLDS',
  PLRF = 'PLRF',
  POPE = 'POPE',
  PPTI = 'PPTI',
  PRCP = 'PRCP',
  PRME = 'PRME',
  PTSP = 'PTSP',
  PTXP = 'PTXP',
  RAPI = 'RAPI',
  RCKE = 'RCKE',
  RCPT = 'RCPT',
  RDTX = 'RDTX',
  REBT = 'REBT',
  REFU = 'REFU',
  RELG = 'RELG',
  RENT = 'RENT',
  REOD = 'REOD',
  REPO = 'REPO',
  RETL = 'RETL',
  RHBS = 'RHBS',
  RIMB = 'RIMB',
  RINP = 'RINP',
  RLWY = 'RLWY',
  RMCO = 'RMCO',
  ROYA = 'ROYA',
  RPBC = 'RPBC',
  RPCC = 'RPCC',
  RPNT = 'RPNT',
  RPSB = 'RPSB',
  RPSC = 'RPSC',
  RRBN = 'RRBN',
  RRCT = 'RRCT',
  RRTP = 'RRTP',
  RVPM = 'RVPM',
  RVPO = 'RVPO',
  SALA = 'SALA',
  SASW = 'SASW',
  SAVG = 'SAVG',
  SBSC = 'SBSC',
  SCIE = 'SCIE',
  SCIR = 'SCIR',
  SCRP = 'SCRP',
  SCVE = 'SCVE',
  SECU = 'SECU',
  SEPI = 'SEPI',
  SERV = 'SERV',
  SHBC = 'SHBC',
  SHCC = 'SHCC',
  SHSL = 'SHSL',
  SLEB = 'SLEB',
  SLOA = 'SLOA',
  SLPI = 'SLPI',
  SPLT = 'SPLT',
  SPSP = 'SPSP',
  SSBE = 'SSBE',
  STDY = 'STDY',
  SUBS = 'SUBS',
  SUPP = 'SUPP',
  SWBC = 'SWBC',
  SWCC = 'SWCC',
  SWFP = 'SWFP',
  SWPP = 'SWPP',
  SWPT = 'SWPT',
  SWRS = 'SWRS',
  SWSB = 'SWSB',
  SWSC = 'SWSC',
  SWUF = 'SWUF',
  TAXR = 'TAXR',
  TAXS = 'TAXS',
  TBAN = 'TBAN',
  TBAS = 'TBAS',
  TBBC = 'TBBC',
  TBCC = 'TBCC',
  TBIL = 'TBIL',
  TCSC = 'TCSC',
  TELI = 'TELI',
  TLRF = 'TLRF',
  TLRR = 'TLRR',
  TMPG = 'TMPG',
  TPRI = 'TPRI',
  TPRP = 'TPRP',
  TRAD = 'TRAD',
  TRCP = 'TRCP',
  TREA = 'TREA',
  TRFD = 'TRFD',
  TRNC = 'TRNC',
  TRPT = 'TRPT',
  TRVC = 'TRVC',
  UBIL = 'UBIL',
  UNIT = 'UNIT',
  VATX = 'VATX',
  VIEW = 'VIEW',
  WEBI = 'WEBI',
  WHLD = 'WHLD',
  WTER = 'WTER',
}
